import { produce } from "immer";
import * as uiActions from "store/actions/uiActions";

const initialState = {
  items: [],
  lastId: 1
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case uiActions.ADD_SNACKBAR: {
      const {
        id = null,
        message,
        actionButton = null,
        status = "success",
        autoHide = true,
        placement = "bottom"
      } = action.payload;

      const snackbarId = id || draft.lastId;
      const snackbar = {
        id: snackbarId,
        message,
        status,
        actionButton,
        autoHide,
        placement
      };

      const existingIndex = draft.items.findIndex(
        item => item.id === snackbarId
      );
      if (existingIndex > -1) {
        draft.items[existingIndex] = snackbar;
      } else {
        draft.items.push(snackbar);
      }

      if (!id) {
        draft.lastId = draft.lastId + 1;
      }

      break;
    }

    case uiActions.REMOVE_SNACKBAR: {
      const payload = action.payload;
      draft.items = draft.items.filter(item => {
        return item.id !== payload.id;
      });

      break;
    }
    default:
      return draft;
  }
}, initialState);

export default reducer;
